import { useContext, useState } from "react";
import api from "../../api";
import { useToast } from "../ToastContext";
import { LoadingContext } from "../LoadingContext";
import { AuthContext } from "../AuthContext";
import { set } from "lodash";

export interface TerceiroType {
    id: number
    name: string;
    email: string;
    cpf?: string;
    telephone?: string;
    telephone_01?: string;
    address?: string;
    addressNumber?: string;
    neighborhood?: string;
    city?: string;
    state?: string;
    zipCode?: string;
    landline?: string;
    bank?: string;
    agency?: string;
    currentAccount?: string;
    observation?: string;
    pix?: string;
    spendingCeiling?: number;
    balanceExpenses?: number;
    isManager?: boolean;
    userId: number;
    empresaId: number;
    tipoTerceiroId: number;
    tipoTerceiroName: string;
}

export interface TerceiroWithConfirmType {
    id: number
    name: string;
    email: string;
    cpf?: string;
    telephone?: string;
    telephone_01?: string;
    address?: string;
    addressNumber?: string;
    neighborhood?: string;
    city?: string;
    state?: string;
    zipCode?: string;
    landline?: string;
    bank?: string;
    agency?: string;
    currentAccount?: string;
    observation?: string;
    pix?: string;
    spendingCeiling?: number;
    balanceExpenses?: number;
    isManager?: boolean;
    userId: number;
    empresaId: number;
    tipoTerceiroId: number;
    tipoTerceiroName: string;
    confirm?: boolean | null;
}

export interface TerceiroServicoInput {
    tipoServicoId: number;
    value: number;
}

export interface TerceiroServicoType {
    servicoId: number;
    servicoName: string;
    value: number;
}

export interface CreateTerceiroType {
    name: string;
    email: string;
    CPF?: string;
    telephone?: string;
    telephone_01?: string;
    address?: string;
    addressNumber?: string;
    neighborhood?: string;
    city?: string;
    state?: string;
    zipCode?: string;
    landline?: string;
    bank?: string;
    agency?: string;
    currentAccount?: string;
    observation?: string;
    pix?: string;
    spendingCeiling?: number;
    isManager?: boolean;
    password: string;
    empresaId: number;
    tipoTerceiroId: number;
    servicos?: TerceiroServicoInput[];
}

export interface EditTerceiroType {
    id: number;
    name: string;
    email: string;
    CPF?: string;
    telephone?: string;
    telephone_01?: string;
    address?: string;
    addressNumber?: string;
    neighborhood?: string;
    city?: string;
    state?: string;
    zipCode?: string;
    landline?: string;
    bank?: string;
    agency?: string;
    currentAccount?: string;
    observation?: string;
    pix?: string;
    spendingCeiling?: number;
    balanceExpenses?: number;
    isManager?: boolean;
    password: string;
    tipoTerceiroId: number;
    servicos?: TerceiroServicoInput[];
}

export default function useTerceiro() {
    const showToast = useToast();
    const { setLoading } = useContext(LoadingContext);
    const { handleLogout, objUserTk } = useContext(AuthContext);
    const [listTerceiro, setListTerceiro] = useState<TerceiroType[]>([]);
    const [listTerceiroByAgenda, setListTerceiroByAgenda] = useState<TerceiroWithConfirmType[]>([]);
    const [pageCount, setPageCount] = useState<number>(0);

    const [listEditor, setListEditor] = useState<TerceiroType[]>([]);
    const [listLaboratory, setListLaboratory] = useState<TerceiroType[]>([]);
    const [listVendedores, setListVendedores] = useState<TerceiroType[]>([]);
    const [listRepresentanteComercial, setListRepresentanteComercial] = useState<TerceiroType[]>([]);
    const [listFotografos, setListFotografos] = useState<TerceiroType[]>([]);

    const [initialListTerceiro, setInitialListTerceiro] = useState<TerceiroType[]>([]);
    const [terceiro, setTerceiro] = useState<TerceiroType>({
        id: 0,
        name: "",
        email: "",
        cpf: "",
        telephone: "",
        telephone_01: "",
        address: "",
        addressNumber: "",
        neighborhood: "",
        city: "",
        state: "",
        zipCode: "",
        landline: "",
        bank: "",
        agency: "",
        currentAccount: "",
        observation: "",
        pix: "",
        spendingCeiling: 0,
        balanceExpenses: 0,
        isManager: false,
        userId: 0,
        empresaId: 0,
        tipoTerceiroId: 0,
        tipoTerceiroName: "",
    });

    function createTerceiro(createTerceiroType: CreateTerceiroType): Promise<CreateTerceiroType | null> {
        setLoading(true);
        return api
            .post(`/Terceiro/create`, createTerceiroType)
            .then((response) => {
                const createdTerceiro: CreateTerceiroType = response.data;
                showToast("success", "Terceiro criado com sucesso.");
                setLoading(false);
                return createdTerceiro;
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    handleLogout();
                    showToast(
                        "error",
                        "Sessão desconectada. Favor login novamente.",
                        error
                    );
                } else {
                    showToast(
                        "error",
                        "Erro ao criar terceiro. Verifique novamente mais tarde.",
                        error
                    );
                }
                setLoading(false);
                console.error("Erro ao criar terceiro:", error);
                return null;
            });
    }

    function getTerceiroPaged(
        pageNumber: number,
        Name?: string,
        EmpresaId?: number,
        pageSize?: number,
        tipoTerceiroName?: string
    ): Promise<TerceiroType[] | null> {
        setLoading(true);
        let url = `/Terceiro/getTerceiroPaged?pageNumber=${pageNumber}&pageSize=${pageSize}`;

        if (Name) {
            url += `&Name=${Name}`;
        }

        if (EmpresaId) {
            url += `&EmpresaId=${EmpresaId}`;
        }

        if (tipoTerceiroName) {
            url += `&tipoTerceiroName=${tipoTerceiroName}`;
        }

        return api
            .get(url)
            .then((response) => {
                setListTerceiro(response.data.result);
                setInitialListTerceiro(response.data.result);
                setPageCount(response.data.pageCount);
                setLoading(false);
                return response.data.result;
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    handleLogout();
                    showToast(
                        "error",
                        "Sessão desconectada. Favor login novamente.",
                        error
                    );
                } else {
                    showToast(
                        "error",
                        "Erro ao carregar terceiro. Verifique novamente mais tarde.",
                        error
                    );
                }
                setLoading(false);
                console.error("Erro ao carregar terceiro:", error);
                return null;
            });
    }

    function updateTerceiro(updateTerceiroData: EditTerceiroType): Promise<EditTerceiroType | null> {
        setLoading(true);
        return api
            .put(`/Terceiro/${updateTerceiroData.id}`, updateTerceiroData)
            .then((response) => {
                showToast("success", "Terceiro atualizada com sucesso.");
                setLoading(false);
                return response.data;
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    handleLogout();
                    showToast(
                        "error",
                        "Sessão desconectada. Favor login novamente.",
                        error
                    );
                } else {
                    showToast(
                        "error",
                        "Erro ao atualizar terceiro. Verifique novamente mais tarde.",
                        error
                    );
                }
                setLoading(false);
                console.error("Erro ao atualizar terceiro:", error);
                return null;
            });
    }

    function deleteTerceiro(terceiroId: number): Promise<TerceiroType | null> {
        setLoading(true);
        return api
            .delete(`/Terceiro/delete/${terceiroId}`)
            .then(() => {
                setTerceiro({
                    id: 0,
                    name: "",
                    email: "",
                    cpf: "",
                    telephone: "",
                    telephone_01: "",
                    address: "",
                    addressNumber: "",
                    neighborhood: "",
                    city: "",
                    state: "",
                    zipCode: "",
                    landline: "",
                    bank: "",
                    agency: "",
                    currentAccount: "",
                    observation: "",
                    pix: "",
                    spendingCeiling: 0,
                    balanceExpenses: 0,
                    isManager: false,
                    userId: 0,
                    empresaId: 0,
                    tipoTerceiroId: 0,
                    tipoTerceiroName: "",
                });
                showToast("success", "Terceiro deletada com sucesso.");
                setLoading(false);
                return null;
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    handleLogout();
                    showToast(
                        "error",
                        "Sessão desconectada. Favor login novamente.",
                        error
                    );
                } else {
                    showToast(
                        "error",
                        "Erro ao deletar terceiro. Verifique novamente mais tarde.",
                        error
                    );
                }
                setLoading(false);
                console.error("Erro ao deletar terceiro:", error);
                return null;
            });
    }

    function handleGetTerceiroByUserId(userId: number): Promise<TerceiroType | null> {
        setLoading(true);
        return api
            .get(`/Terceiro/getTerceiroByUserId/${userId}`)
            .then((response) => {
                const terceiro: TerceiroType = response.data;
                setTerceiro(terceiro);
                setLoading(false);
                return terceiro;
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    handleLogout();
                    showToast(
                        "error",
                        "Sessão desconectada. Favor login novamente.",
                        error
                    );
                } else {
                    showToast(
                        "error",
                        "Erro ao buscar informações do terceiro. Verifique novamente mais tarde.",
                        error
                    );
                }
                setLoading(false);
                console.error("Erro ao buscar informações do terceiro:", error);
                return null;
            });
    }

    function handleGetTerceiroById(terceiroId: number): Promise<TerceiroType | null> {
        setLoading(true);
        return api
            .get(`/Terceiro/${terceiroId}`)
            .then((response) => {
                const terceiro: TerceiroType = response.data;
                setTerceiro(terceiro);
                setLoading(false);
                return terceiro;
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    handleLogout();
                    showToast(
                        "error",
                        "Sessão desconectada. Favor login novamente.",
                        error
                    );
                } else {
                    showToast(
                        "error",
                        "Erro ao buscar terceiro pelo ID. Verifique novamente mais tarde.",
                        error
                    );
                }
                setLoading(false);
                console.error("Erro ao buscar terceiro pelo ID:", error);
                return null;
            });
    }

    function handleGetTerceiroByAgendaId(agendaId: number): Promise<TerceiroWithConfirmType[] | null> {
        setLoading(true);
        return api
            .get(`/Terceiro/getTerceirorByAgendaId?agendaId=${agendaId}`)
            .then((response) => {
                const terceiro: TerceiroWithConfirmType[] = response.data;
                setListTerceiroByAgenda(terceiro);
                setLoading(false);
                return terceiro;
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    handleLogout();
                    showToast(
                        "error",
                        "Sessão desconectada. Favor login novamente.",
                        error
                    );
                } else {
                    showToast(
                        "error",
                        "Erro ao buscar informações do terceiro. Verifique novamente mais tarde.",
                        error
                    );
                }
                setLoading(false);
                console.error("Erro ao buscar informações do terceiro:", error);
                return null;
            });
    }

    function handleGetEditorsByEmpresa(empresaId: number): Promise<TerceiroType[] | null> {
        setLoading(true);
        return api
            .get(`/Terceiro/getTerceirosByTipoForEmpresa?empresaId=${empresaId}&tipo=EDITOR`)
            .then((response) => {
                const list = response.data as TerceiroType[];
                setListEditor(list);
                setLoading(false);
                return list;
            })
            .catch((error) => {
                console.error(error);
                setLoading(false);
                return null;
            });
    }

    function handleGetLaboratoriesByEmpresa(empresaId: number): Promise<TerceiroType[] | null> {
        setLoading(true);
        return api
            .get(`/Terceiro/getTerceirosByTipoForEmpresa?${new URLSearchParams({ empresaId: String(empresaId), tipo: 'LABORATÓRIO' })}`)
            .then((response) => {
                const list = response.data as TerceiroType[];
                setListLaboratory(list);
                setLoading(false);
                return list;
            })
            .catch((error) => {
                console.error(error);
                setLoading(false);
                return null;
            });
    }

    function handleGetVendedoresByEmpresa(empresaId: number): Promise<TerceiroType[] | null> {
        setLoading(true);
        return api
            .get(`/Terceiro/getTerceirosByTipoForEmpresa?empresaId=${empresaId}&tipo=VENDEDOR`)
            .then((response) => {
                const list = response.data as TerceiroType[];
                setListVendedores(list);
                setLoading(false);
                return list;
            })
            .catch((error) => {
                console.error(error);
                setLoading(false);
                return null;
            });
    }

    function handleGetRepresentanteComercialByEmpresa(empresaId: number): Promise<TerceiroType[] | null> {
        setLoading(true);
        return api
            .get(`/Terceiro/getTerceirosByTipoForEmpresa?${new URLSearchParams({ empresaId: String(empresaId), tipo: 'REPRESENTANTE COMERCIAL' })}`)
            .then((response) => {
                const list = response.data as TerceiroType[];
                setListRepresentanteComercial(list);
                setLoading(false);
                return list;
            })
            .catch((error) => {
                console.error(error);
                setLoading(false);
                return null;
            });
    }

    function handleGetFotografosByEmpresa(empresaId: number): Promise<TerceiroType[] | null> {
        setLoading(true);
        return api
            .get(`/Terceiro/getTerceirosByTipoForEmpresa?${new URLSearchParams({ empresaId: String(empresaId), tipo: 'FOTÓGRAFO' })}`)
            .then((response) => {
                const list = response.data as TerceiroType[];
                setListFotografos(list);
                setLoading(false);
                return list;
            })
            .catch((error) => {
                console.error(error);
                setLoading(false);
                return null;
            });
    }

    // function removeServicoDoTerceiro(terceiroId: number, tipoServicoId: number): Promise<boolean> {
    //     setLoading(true);
    //     return api
    //         .delete(`/Terceiro/${terceiroId}/servicos/${tipoServicoId}`)
    //         .then(() => {
    //             showToast("success", "Serviço desvinculado do terceiro com sucesso.");
    //             setLoading(false);
    //             return true;
    //         })
    //         .catch((error) => {
    //             if (error?.response?.status === 401) {
    //                 handleLogout();
    //                 showToast("error", "Sessão desconectada. Favor login novamente.", error);
    //             } else if (error?.response?.status === 404) {
    //                 showToast("error", "Relação não encontrada para este terceiro e serviço.", error);
    //             } else {
    //                 showToast("error", "Erro ao desvincular serviço do terceiro.", error);
    //             }
    //             setLoading(false);
    //             console.error("Erro ao remover serviço do terceiro:", error);
    //             return false;
    //         });
    // }

    function handleGetServicosByTerceiro(terceiroId: number): Promise<TerceiroServicoType[] | null> {
        setLoading(true);
        return api
            .get(`/Terceiro/${terceiroId}/servicos`)
            .then((response) => {
                setLoading(false);
                return response.data as TerceiroServicoType[];
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    handleLogout();
                    showToast("error", "Sessão desconectada. Favor login novamente.", error);
                } else {
                    showToast("error", "Erro ao buscar serviços do terceiro.", error);
                }
                setLoading(false);
                console.error("Erro ao buscar serviços do terceiro:", error);
                return null;
            });
    }

    function addServicoToTerceiro(input: { terceiroId: number; tipoServicoId: number; value: number }): Promise<boolean> {
        setLoading(true);
        return api
            .post(`/Terceiro/${input.terceiroId}/servicos`, {
                tipoServicoId: input.tipoServicoId,
                value: input.value,
            })
            .then(() => {
                showToast("success", "Serviço vinculado ao terceiro com sucesso.");
                setLoading(false);
                return true;
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    handleLogout();
                    showToast("error", "Sessão desconectada. Favor login novamente.", error);
                } else {
                    showToast("error", "Erro ao vincular serviço ao terceiro.", error);
                }
                setLoading(false);
                console.error("Erro ao adicionar serviço ao terceiro:", error);
                return false;
            });
    }

    function updateValorServicoTerceiro(input: { terceiroId: number; tipoServicoId: number; value: number }): Promise<boolean> {
        setLoading(true);
        return api
            .put(`/Terceiro/${input.terceiroId}/servicos/${input.tipoServicoId}`, {
                value: input.value,
            })
            .then(() => {
                showToast("success", "Valor do serviço atualizado com sucesso.");
                setLoading(false);
                return true;
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    handleLogout();
                    showToast("error", "Sessão desconectada. Favor login novamente.", error);
                } else if (error?.response?.status === 404) {
                    showToast("error", "Relação de serviço não encontrada para este terceiro.", error);
                } else {
                    showToast("error", "Erro ao atualizar valor do serviço.", error);
                }
                setLoading(false);
                console.error("Erro ao atualizar valor do serviço:", error);
                return false;
            });
    }

    function removeServicoDoTerceiro(terceiroId: number, tipoServicoId: number): Promise<boolean> {
        setLoading(true);
        return api
            .delete(`/Terceiro/${terceiroId}/servicos/${tipoServicoId}`)
            .then(() => {
                showToast("success", "Serviço desvinculado do terceiro com sucesso.");
                setLoading(false);
                return true;
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    handleLogout();
                    showToast("error", "Sessão desconectada. Favor login novamente.", error);
                } else if (error?.response?.status === 404) {
                    showToast("error", "Relação não encontrada para este terceiro e serviço.", error);
                } else {
                    showToast("error", "Erro ao desvincular serviço do terceiro.", error);
                }
                setLoading(false);
                console.error("Erro ao remover serviço do terceiro:", error);
                return false;
            });
    }

    function removeServicoFromTerceiro(input: { terceiroId: number; tipoServicoId: number }): Promise<boolean> {
        return removeServicoDoTerceiro(input.terceiroId, input.tipoServicoId);
    }

    return {
        createTerceiro,
        getTerceiroPaged,
        updateTerceiro,
        deleteTerceiro,
        handleGetTerceiroByUserId,
        handleGetTerceiroById,
        setListTerceiro,
        listTerceiro,
        setPageCount,
        pageCount,
        setInitialListTerceiro,
        initialListTerceiro,
        setTerceiro,
        terceiro,
        handleGetTerceiroByAgendaId,
        listTerceiroByAgenda,
        handleGetEditorsByEmpresa,
        listEditor,
        handleGetLaboratoriesByEmpresa,
        listLaboratory,
        handleGetVendedoresByEmpresa,
        listVendedores,
        handleGetRepresentanteComercialByEmpresa,
        listRepresentanteComercial,
        handleGetFotografosByEmpresa,
        listFotografos,
        // removeServicoDoTerceiro,
        handleGetServicosByTerceiro,
        addServicoToTerceiro,
        updateValorServicoTerceiro,
        removeServicoDoTerceiro,
        removeServicoFromTerceiro,
    };
}
